type BaseOptions = {
  key?: string
  currency: string
  name: string
  description?: string
  image: string
  handler?: () => void
  prefill?: {
    name?: string
    email?: string
    contact?: string
  }
  theme?: {
    color?: string
  }
  config: any
  modal: any
}

type OrderOptions = BaseOptions & {
  order_id: string
  subscription_id?: never
  subscription_card_change?: never
}
type SubscriptionOptions = BaseOptions & {
  subscription_id: string
  order_id?: never
  subscription_card_change: boolean
}
type Options = OrderOptions | SubscriptionOptions

const openRZP = (options: Options) => {
  // console.log("openRZP Options:", options)
  // @ts-expect-error testing
  const rzp = new window.Razorpay(options)
  rzp.open()
}

export function init(options: Omit<OrderOptions, "config" | "modal">): void
export function init(
  options: Omit<SubscriptionOptions, "config" | "modal">
): void
export function init(options): void {
  const fullOptions = {
    key: import.meta.env.VITE_RAZORPAY_KEY,
    theme: {
      // Suraasa primary color
      color: "#315EFB",
    },
    config: {
      display: {
        blocks: {
          banks: {
            name: "All payment methods",
            instruments: [
              {
                method: "card",
              },
              {
                method: "upi",
              },
              {
                method: "netbanking",
              },
              {
                method: "wallet",
              },
            ],
          },
        },
        sequence: ["block.banks"],
        preferences: {
          show_default_blocks: false,
        },
      },
    },
    modal: {
      ondismiss: function () {
        window.location.reload()
      },
    },
    ...options,
  }

  openRZP(fullOptions)
}
